module.exports = __webpack_public_path__ + "static/media/fundis-logo.f62e629c.svg";